import { Form, Select } from 'antd'
import React from 'react'
import SendEvent from './SendEvent'

const actions = [
    {
        label: 'Enviar Evento',
        value: 'SEND_EVENT',
    },
]

export default function MetaAdsForm({ form, fieldName, integrationId }) {
    const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

    return (
        <>
            <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
                <Select options={actions} placeholder={'Selecione o tipo de ação'} />
            </Form.Item>
            {type === 'SEND_EVENT' && (
                <SendEvent
                    form={form}
                    fieldName={fieldName}
                    integrationId={integrationId}
                />
            )}
        </>
    )
}
